// Global Acorn Finance Link Dynamic Updates
document.addEventListener('DOMContentLoaded', function() {
  
  // Global function to update Acorn Finance links with dynamic pricing
  window.updateAcornFinanceLinks = function() {
    const acornLinks = document.querySelectorAll('a[href*="acornfinance.com"]');
    if (acornLinks.length === 0) return;
    
    // Try to get price from various sources in order of preference
    let loanAmount = null;
    
    // 1. Try simulator builder total price
    const simulatorPrice = document.getElementById('total-price');
    if (simulatorPrice) {
      const priceText = simulatorPrice.textContent.replace(/[^0-9.]/g, '');
      loanAmount = parseFloat(priceText);
    }
    
    // 2. Try product price from product pages
    if (!loanAmount || loanAmount < 1000) {
      const productPrice = document.querySelector('.price__regular .price-item--regular, .product__price .price, [data-product-price]');
      if (productPrice) {
        const priceText = productPrice.textContent.replace(/[^0-9.]/g, '');
        loanAmount = parseFloat(priceText);
      }
    }
    
    // 3. Try to extract from page context or URL
    if (!loanAmount || loanAmount < 1000) {
      // For product builder pages, use reasonable defaults based on URL
      const path = window.location.pathname.toLowerCase();
      if (path.includes('elite')) {
        loanAmount = 50000;
      } else if (path.includes('omega')) {
        loanAmount = 35000;
      } else if (path.includes('pro')) {
        loanAmount = 25000;
      } else {
        loanAmount = 25000; // Default fallback
      }
    }
    
    // Update all Acorn Finance links
    acornLinks.forEach(link => {
      try {
        const url = new URL(link.href);
        url.searchParams.set('loanAmount', Math.round(loanAmount));
        link.href = url.toString();
      } catch (error) {
        // Silent fail for individual links
      }
    });
  };
  
  // Update links immediately
  window.updateAcornFinanceLinks();
  
  // Update periodically for dynamic content
  setInterval(window.updateAcornFinanceLinks, 3000);
  
  // Update when price changes (for simulator builder)
  const priceObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.id === 'total-price' || 
          mutation.target.classList.contains('price') ||
          mutation.target.dataset.productPrice !== undefined) {
        setTimeout(window.updateAcornFinanceLinks, 100);
      }
    });
  });
  
  // Observe price elements for changes
  const priceElements = document.querySelectorAll('#total-price, .price, [data-product-price]');
  priceElements.forEach(element => {
    priceObserver.observe(element, { 
      childList: true, 
      subtree: true, 
      characterData: true 
    });
  });

});

// SEO render repair for storefront pages whose full HTML render can lag behind fresh section rendering.
// Keep this duplicate-safe: each repair checks the existing DOM before changing anything.
document.addEventListener('DOMContentLoaded', function() {
  var path = window.location.pathname.toLowerCase();

  if (
    path.indexOf('/products/elite-simulator-builder') === 0 ||
    path.indexOf('/products/omega-simulator-builder') === 0 ||
    path.indexOf('/products/pro-simulator-builder') === 0
  ) {
    var depositSection = document.querySelector('.deposit-section');
    var note = document.querySelector('.deposit-section .deposit-note');
    if (
      depositSection &&
      note &&
      !depositSection.querySelector('.deposit-clarity') &&
      depositSection.textContent.indexOf('due today is a build deposit') === -1
    ) {
      var clarity = document.createElement('div');
      clarity.className = 'deposit-clarity';
      clarity.innerHTML = '<strong>$200 due today is a build deposit.</strong> The total build price above is the full MSRP/starting system price before any configuration changes, taxes, card fees, or remaining payment schedule.';
      note.insertAdjacentElement('afterend', clarity);
    }
  }

  if (
    path.indexOf('/products/hydraulic-sim-pedals') === 0 ||
    path.indexOf('/products/hydraulic-sim-racing-handbrake') === 0
  ) {
    document.querySelectorAll('.product-title').forEach(function(title, index) {
      if (index === 0 || title.tagName.toLowerCase() !== 'h1') return;
      var replacement = document.createElement('div');
      replacement.className = title.className;
      replacement.innerHTML = title.innerHTML;
      title.getAttributeNames().forEach(function(name) {
        if (name !== 'class') replacement.setAttribute(name, title.getAttribute(name));
      });
      title.replaceWith(replacement);
    });

    document.querySelectorAll('.pedals-hero__title').forEach(function(title) {
      if (title.tagName.toLowerCase() !== 'h1') return;
      var replacement = document.createElement('h2');
      replacement.className = title.className;
      replacement.innerHTML = title.innerHTML;
      title.getAttributeNames().forEach(function(name) {
        if (name !== 'class') replacement.setAttribute(name, title.getAttribute(name));
      });
      title.replaceWith(replacement);
    });
  }
});
